export const DISPLAY_MODE_FULL = "full";

export const COURSE_TYPE_ONLINE = "Online";
export const COURSE_TYPE_CLASSROOM = "Classroom";
export const COURSE_TYPE_ACTIVITY = "Activity";

export const COLOR_PROGRESS = "rgba(45, 85, 40, 0.8)";

export const PROGRESS_ALL = "all";
export const FILTER_TODO = "lefttodo";
export const FILTER_DONE = "completed";
export const FILTER_ONGOING = "begun";
export const MODE_FULL = "full";
export const MODE_SIMPLE = "simple";
export const NOOFCOURSES = 5;

export const SORT_TITLE = "title";
export const SORT_LAST_LOGGED_IN = "lastloggedin";
export const SORT_CREATED_DATE = "createddate";

export const SORT_OPTIONS_ORDER = [
  { value: SORT_TITLE, label: "Lettersorting" },
  { value: SORT_LAST_LOGGED_IN, label: "Recentlyaccessed" },
  { value: SORT_CREATED_DATE, label: "Recentlyenrolled" },
];

export const SORT_OPTIONS_STATUS = [
  { value: "all", label: "all" },
  { value: "lefttodo", label: "lefttodo" },
  { value: "notstarted", label: "notstarted" },
  { value: "begun", label: "begun" },
  { value: "completed", label: "finished2" },
];

export const VIEWPORT_X_SMALL = "x-small";
export const VIEWPORT_SMALL = "small";
export const VIEWPORT_MEDIUM = "medium";
export const VIEWPORT_LARGE = "large";

export const STORAGE_KEY_SORT_ORDER = "Mycourses_sortOrder";
export const STORAGE_KEY_FILTER_STATUS = "Mycourses_filterStatus";
